var map = {
	"./back.svg": 412,
	"./close.svg": 98179,
	"./closeMenu.svg": 45882,
	"./copy.svg": 78838,
	"./eth.svg": 43322,
	"./icon-bottom.svg": 53982,
	"./icon-exit.svg": 80455,
	"./icon-head-exit.svg": 6838,
	"./icon-tg.svg": 30836,
	"./icon-x.svg": 45661,
	"./link1.svg": 60430,
	"./link2.svg": 8781,
	"./link3.svg": 9836,
	"./menu.svg": 88804,
	"./nav1.svg": 27381,
	"./nav2.svg": 14422,
	"./nav3.svg": 53959,
	"./nav4.svg": 16360,
	"./right.svg": 45605,
	"./search.svg": 58217,
	"./share.svg": 85702,
	"./success.svg": 51530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;